export default __webpack_public_path__ + "static/media/DSC01950.3c829db0.jpeg";